const AbstractSyncer = require('@/lib/Syncing/AbstractSyncer');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const EventNames = require('@/lib/Events/EventNames');
const logFactory = require('@/libraries/DigiTickets/Logging/logFactory');

/**
 * This class is used to sync items which do not have a branch or where the branch is not important.
 * If the branch is important the ItemsSyncer should be used.
 */
class EposDataSyncer extends AbstractSyncer {
    // This duplication of parameters being passed to the superclass' constructor looks silly but it's
    // necessary for Angular's injector to work.
    constructor(
        $injector,
        dataStore,
        eventBus,
        localStorageDataStore,
        syncStateManager
    ) {
        super(
            $injector,
            dataStore,
            eventBus,
            localStorageDataStore,
            syncStateManager
        );

        /**
         * @type {ConsoleLogger}
         */
        this.log = logFactory('EposDataSyncer');
    }

    getManagedTableNames() {
        return [
            // This should be things that don't have a branch,
            // or where the branch is not relevant to items being sold.
            DataStoreNames.CATEGORIES,
            DataStoreNames.FIELDS,
            DataStoreNames.GIFT_AID_RATES,
            DataStoreNames.KITCHEN_ZONES,
            DataStoreNames.MARKETING_PREFERENCES,
            DataStoreNames.OFFERS,
            DataStoreNames.RETURN_REASONS,
            DataStoreNames.SESSION_EVENTS, // These are events. Sessions are synced by ItemsSyncer.
            DataStoreNames.TEMPLATES,
        ];
    }

    getSyncFunctions() {
        return [
            this.createSyncRepositoryFunction(DataStoreNames.CATEGORIES, 'categoryRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.FIELDS, 'fieldRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.GIFT_AID_RATES, 'giftAidRateRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.KITCHEN_ZONES, 'kitchenZoneRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.MARKETING_PREFERENCES, 'marketingPreferenceRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.OFFERS, 'offerRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.RETURN_REASONS, 'returnReasonRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.SESSION_EVENTS, 'sessionEventRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.TEMPLATES, 'templateRepository'),
        ];
    }

    requiresBranch() {
        return true;
    }

    onSyncFinish() {
        this.eventBus.broadcast(EventNames.EPOS_DATA_SYNCED);
    }
}

module.exports = EposDataSyncer;
